import { atom } from "recoil";
import { User } from "../model";

export const userState = atom<User | undefined>({
  key: 'userState',
  default: undefined,
});